import { ApartmentOutlined, ArrowLeftOutlined, BarsOutlined, DeleteOutlined, DownOutlined, PlusCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { ConfigProvider, DatePicker, Input, Pagination, Select, Splitter } from 'antd';
import { PaginationProps } from 'antd/lib';
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import React, { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getListFieldsByCustomer, ListField } from '../../../api/Customer_V2/customerApi_V2';
import * as groupCustomerV2Api from '../../../api/groupCustomerV2/groupCustomerV2Api';
import { getCLStaff, IStaff } from '../../../api/selectOption/selectOptionsApi';
import { getListCarCompany, getSLCategoryCarByPermission, getSLUnitByPermission, getSLUnitOption, ISelectOption } from '../../../api/selectOptions/selectOptionsApi';
import { convertNationwideValueToTree_V2 } from '../../../api/unit/unitApi';
import BreadcrumbBlock from '../../../components/BreadcrumbBlock/BreadcrumbBlock';
import { no_access } from '../../../components/ExportImgFigma';
import useDebounce from '../../../hook/useDebounce';
import useLoading from '../../../hook/useLoading';
import useToast from '../../../hook/useToast';
import Layout from '../../../Layout';
import { dataTypeGroup, FIELDTYPE } from '../../../services/data';
import { formatNumber } from '../../../services/mixin';
import { selectorCategoryCarIds } from '../../../store/slices/categoryCarSlice';
import { setGroupCustumer } from "../../../store/slices/groupCustumerSlice";
import { selectorInfoUser } from '../../../store/slices/infoUserSlice';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { dataPagination, fommatSelectOption, fommatSelectOptionCreator, getUserPermissions, handleDateChangeDayJs, handleStringToDayJs } from '../../../until';
import { FlattenedField } from '../../CustomersV2/indexV2';
import { ColumnKey } from '../Tabs/CarListCardClone';
import AddNewGroup from './Component/AddGroup/AddNewGroup';
import CombineGroup from './Component/CombineGroup/CombineGroup';
import EditGroup from './Component/EditGroup/EditGroup';
import GroupCustomerTypeTree from './Component/GroupCustomerTypeTree';
import ModalDeleteGroup from './Component/Modal/ModalDeleteGroupV2';
import Sidebar, { NodeEvent, TreeNode } from './Component/SideBar';
import ViewGroup from './Component/ViewGroup/ViewGroup';
import './style.scss';
import CustomerFeilds from '../../CustomersV2/Drawer/CustomerFeilds';
import { PERMISSION } from './Component/AddGroup/Component/AG_Decentralization';
import { initInfoOperator } from './Component/Modal/ModalAddAndEditCondition';
import { filterInfoOperatoToConditions } from '../../../apiSync/customerGroup/customerGroupApi';
import CustomerFeildsGroup from '../../CustomersV2/Drawer/CustomerFeildsGroup';
dayjs.locale('vi');

const { RangePicker } = DatePicker;

export const convertTreeForAntd = (data: TreeNode[]): any[] => {
  return data.map((item: TreeNode) => ({
    ...item,
    key: item.key,
    label: item.title,
    value: item.key,
    level: item.level,
    parentId: item.parentId,
    children: item.children ? convertTreeForAntd(item.children) : undefined

  }));
};

type UserContextType = {
  isModalLoadingSync: boolean
  isLoadingListUnmatchedSync: boolean
  displayType: EDisplayGroupType;
  dataFilterList: IDataDefaulFilterList;
  // sLUnit: ISelectOption[]
  sLCategoryCar: ISelectOption[]
  sLNationwide: any[]

  inforNodeEvent?: NodeEvent
  itemCombineGroup: number[]
  isPreview: boolean;
  isPrivate: boolean;

  dataFieldsActive: FlattenedField[];
  dataFieldsNoActive: ListField[];
  ColumnsMapShow: ColumnKey[];
  listGroup: TreeNode[];
  infoOperator: groupCustomerV2Api.IVConditionFilterV2
  // const [infoOperator, setInfoOperator] = useState<IVConditionFilterV2>(initInfoOperator)
  setInfoOperator: React.Dispatch<React.SetStateAction<groupCustomerV2Api.IVConditionFilterV2>>
  setIsModalLoadingSync: React.Dispatch<React.SetStateAction<boolean>>
  setIsLoadingListUnmatchedSync: React.Dispatch<React.SetStateAction<boolean>>
  setDataFilterList: (e: IDataDefaulFilterList) => void
  setInforNodeEvent: React.Dispatch<React.SetStateAction<NodeEvent | undefined>>;
  setPrivate: React.Dispatch<React.SetStateAction<boolean>>;
  setPreview: React.Dispatch<React.SetStateAction<boolean>>;
  setDataFieldsActive: React.Dispatch<React.SetStateAction<FlattenedField[]>>;
  setDataFieldsNoActive: React.Dispatch<React.SetStateAction<ListField[]>>;
  setColumnsMapShow: React.Dispatch<React.SetStateAction<ColumnKey[]>>;
  handleOpenDataFields: () => void

  onSubmitFormModalAdd: (iSsuccess: boolean, message?: string, inforNodeEvent?: NodeEvent) => void
  onSubmitFormModalUpdate: (iSsuccess: boolean, message?: string) => void
  onSubmitFormCombine: (iSsuccess: boolean, message?: string) => void
};

const GroupContext = createContext<UserContextType | null>(null);


export interface IDataDefaulFilterList {
  adminId?: number | undefined,
  status?: number | undefined,
  dateStart?: string,
  dateEnd?: string,
  search?: string
}

export const dataDefaulFilterList: IDataDefaulFilterList = {
  adminId: undefined,
  status: undefined,
  dateStart: undefined,
  dateEnd: undefined,
  search: undefined
};

export enum EDisplayGroupType {
  LIST = 1,      // hiển thị dạng danh sách phẳng (không có cấp con)
  TREE = 0,      // hiển thị dạng cây thư mục (cha – con)
  PARENT = 2    // hiển thị dạng danh sách chỉ có nhóm cha
}


/**
 * Chuyển IGroup[] sang Node[] để dùng cho Tree.
 * - Đệ quy theo `children`
 * - Giữ lại `parentId` nếu cần tra cứu ngược
 * - Cho phép custom cách tạo `key`
 */
export function convertGroupsToTreeNode(
  groups: groupCustomerV2Api.IGroup[] | undefined | null,
  makeKey: (id: number) => string = (id) => String(id)
): TreeNode[] {
  if (!groups || !Array.isArray(groups)) return [];

  const toNode = (g: groupCustomerV2Api.IGroup | groupCustomerV2Api.IGroupChildren): TreeNode => {
    const kids = Array.isArray(g.children) ? g.children : [];
    const children = kids.length ? kids.map(toNode) : undefined;

    return {
      key: makeKey(g.id),
      title: g.title,
      level: g.level,         // string hợp lệ với React.ReactNode
      customerCount: g.customerCount,
      parentId: g.parentId,
      isDel: g.permissionType === PERMISSION.DELETE,
      ...(children ? { children } : {})
    };
  };

  return groups.map(toNode);
}


// chuyển list phẳng sang có dataPath (mảng các title từ root -> node)
function buildPathMap(rows: groupCustomerV2Api.IGroupTypeList[]): Record<number, string[]> {
  const byId = new Map<number, groupCustomerV2Api.IGroupTypeList>();
  rows.forEach(r => byId.set(r.id, r));

  const memo = new Map<number, string[]>();
  const pathOf = (id: number): string[] => {
    if (memo.has(id)) return memo.get(id)!;
    const node = byId.get(id);
    if (!node) return [];
    if (node.parentId == null) {
      const p = [node.title];
      memo.set(id, p);
      return p;
    }
    const parentPath = pathOf(node.parentId);
    const p = [...parentPath, node.title];
    memo.set(id, p);
    return p;
  };

  const result: Record<number, string[]> = {};
  rows.forEach(r => { result[r.id] = pathOf(r.id); });
  return result;
}

// thêm trường dataPath vào mỗi record (AG Grid không bắt buộc property name, bạn tự quyết)
export type RowWithPath = groupCustomerV2Api.IGroupTypeList & { dataPath: string[] };

export function attachDataPath(rows: groupCustomerV2Api.IGroupTypeList[]): RowWithPath[] {
  const pathMap = buildPathMap(rows);
  return rows.map(r => ({ ...r, dataPath: pathMap[r.id] }));
}

const CustomerGroupV2: React.FC = () => {


  useEffect(() => {
    gListFieldsActive()
    gSLStaff()

    let unmounted = false;
    (async () => {
      const [resUnit, resCar] = await Promise.all([getSLUnitOption(), getSLCategoryCarByPermission(permittedCategoryCarIds)]);
      // if (!unmounted && resUnit?.status) setSLUnit(fommatSelectOptionUnit(resUnit.data));
      if (!unmounted && resCar?.status) setSLCategoryCar(fommatSelectOption(resCar.data));
    })();
    return () => {

      setDataFieldsActive([])
      setDataFieldsNoActive([])

      setDataFilterList(dataDefaulFilterList)

      setSelectedIdGroup(new Set())
      setInforNodeEvent(undefined)
      setItemCombineGroup([])

      unmounted = true;
    }
  }, [])



  const location = useLocation();
  const pushToast = useToast();
  const navigate = useNavigate()
  const pushLoading = useLoading()
  const permissionSlice = useSelector(selectorPermission)
  const { unitTemp, id } = useSelector(selectorInfoUser)
  const { add, edit, delete: isDelete } = getUserPermissions(permissionSlice, location.pathname)
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

  const dispatch = useDispatch();

  const {
    isMenu, inforNodeEvent: inforNodeEventLocation

  } = location?.state || {}


  const isMenuRef = useRef(false)
  const [infoOperator, setInfoOperator] = useState<groupCustomerV2Api.IVConditionFilterV2>(initInfoOperator)
  const [isOpenModalDeleteGroup, setIsOpenModalDeleteGroup] = useState(false)
  const [isModalLoadingSync, setIsModalLoadingSync] = useState<boolean>(false)
  const [isLoadingListUnmatchedSync, setIsLoadingListUnmatchedSync] = useState<boolean>(false)

  const [isSettingFields, setIsSettingFields] = useState(false)

  const [isPreview, setPreview] = useState<boolean>(false);
  const [isPrivate, setPrivate] = useState<boolean>(false);

  const [isAccess, setAccess] = useState<boolean>(true)

  const [selectedIdGroup, setSelectedIdGroup] = useState<Set<Number>>(new Set());

  // const [typeGroupDisplay, setTypeGroupDisplay] = useState<EDisplayGroupType>(EDisplayGroupType.TREE)
  const [displayType, setDisplayType] = useState<EDisplayGroupType>(EDisplayGroupType.TREE);

  const [dataFieldsActive, setDataFieldsActive] = useState<FlattenedField[]>([])
  const [dataFieldsNoActive, setDataFieldsNoActive] = useState<ListField[]>([])
  const [ColumnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([])
  const [pagination, setPagination] = useState({ current: 1, pageSize: 30, total: 0 });

  // const [sLUnit, setSLUnit] = useState<ISelectOption[]>([]);
  const [sLCategoryCar, setSLCategoryCar] = useState<ISelectOption[]>([]);
  const [sLStaff, setSLStaff] = useState<IStaff[]>([])
  const [sLNationwide, setSLNationwide] = useState<any>()

  const [dataFilterList, setDataFilterList] = useState<IDataDefaulFilterList>(dataDefaulFilterList)

  const [inforNodeEvent, setInforNodeEvent] = useState<NodeEvent>()
  const [itemCombineGroup, setItemCombineGroup] = useState<number[]>([])
  const [listGroup, setListGroup] = useState<TreeNode[]>([])
  const [listGroupTypeList, setListGroupTypeList] = useState<groupCustomerV2Api.IGroupTypeList[]>([])

  useEffect(() => {
    if (listGroup.length && location) {
      const searchParams = new URLSearchParams(location.search);
      const idGroupCustomer = searchParams.get('idgroupcustomer');
      if (!idGroupCustomer) return;
      const findNodeRecursive = (nodes: TreeNode[]): TreeNode | undefined => {
        for (const node of nodes) {
          if (node.key === idGroupCustomer) return node;
          if (node.children?.length) {
            const found = findNodeRecursive(node.children as TreeNode[]);
            if (found) return found;
          }
        }
        return undefined;
      };
      const findData = findNodeRecursive(listGroup);
      if (findData) {
        setInforNodeEvent({
          action: "view",
          item: findData
        });
      }
    }
  }, [listGroup, location])

  const renderTitlePage = useMemo(() => {
    switch (inforNodeEvent?.action) {
      case 'add':
        return ('Thêm mới nhóm khách hàng')
      case 'combine':
        return ('Thêm mới nhóm khách hàng')
      case 'update':
        return ('Chỉnh sửa nhóm khách hàng')
      case 'view':
        return ('Chi tiết nhóm khách hàng')
      default:
        return ('Quản lý nhóm khách hàng')
    }
  }, [inforNodeEvent?.action])

  const gListFieldsActive = async () => {
    pushLoading(true)
    const conditions = filterInfoOperatoToConditions(infoOperator)
    const result = await getListFieldsByCustomer(FIELDTYPE.CustomerInGroup, 1, undefined, conditions)
    if (result?.status) {
      const flattenedFields = result.data.flatMap(choice =>
        choice.fields.map(field => ({
          ...field,
          parentId: choice.id,
        }))
      );
      setDataFieldsActive(flattenedFields)
      gListFieldsNotActive()
    }
    pushLoading(false)
  }

  const gListFieldsNotActive = async () => {
    pushLoading(true)
    const conditions = filterInfoOperatoToConditions(infoOperator)
    const result = await getListFieldsByCustomer(FIELDTYPE.CustomerInGroup, 0, undefined, conditions)
    if (result?.status) {
      setDataFieldsNoActive(result.data)
    }
    pushLoading(false)
  }

  const gSLStaff = async () => {
    pushLoading(true)
    const result = await getCLStaff()
    if (result?.status) {
      setSLStaff(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }

  const gListGroup = useDebounce(async (limit: number = 30, pageNumber: number = 1) => {
    const {
      adminId, status, dateStart, dateEnd, search
    } = dataFilterList
    const limitTmp = displayType === EDisplayGroupType.TREE ? undefined : limit
    const pageNumberTmp = displayType === EDisplayGroupType.TREE ? undefined : pageNumber
    pushLoading(true)
    const result = await groupCustomerV2Api.getListGroup(
      permittedCategoryCarIds,
      adminId, status === 2 ? undefined : status, dateStart || undefined, dateEnd || undefined,
      search, displayType, limitTmp, pageNumberTmp,
      unitTemp
    )
    if (result.status) {
      if (displayType === EDisplayGroupType.TREE) {
        setListGroup(convertGroupsToTreeNode(result.data))
        if (result.data.length && isMenuRef.current) {
          const { id, level, parentId, title, children, permissionType } = result.data[0]
          const inforNodeEventTmp: NodeEvent = {
            action: 'view',
            item: {
              key: id.toString(),
              level,
              title,
              parentId,
              isDel: !!permissionType
            }
          }
          edit && setInforNodeEvent(inforNodeEventTmp)
          isMenuRef.current = false
        }
      }
      else {
        setListGroupTypeList(result.data as groupCustomerV2Api.IGroupTypeList[])
        setPagination({ current: pageNumber, total: result.total, pageSize: limit });
      }

    } else {
      pushToast(result.message, "warning")
      setListGroup([])
    }
    pushLoading(false)
  }, 1000)


  const onSubmitFormModalAdd = (iSsuccess: boolean, message?: string, inforNodeEvent?: NodeEvent) => {
    if (iSsuccess) {
      setInforNodeEvent(inforNodeEvent)

      pushToast(message, "success")
      // setInforNodeEvent(undefined)
      gListGroup(pagination.pageSize, pagination.current)

      // setInforNodeEvent({ ...inforNodeEvent, action: "view" })
    }
    else {
      pushToast(message, "warning")
    }
  }

  const onSubmitFormModalUpdate = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      pushToast(message, "success")
      // setInforNodeEvent(undefined)
      gListGroup(pagination.pageSize, pagination.current)

      setInforNodeEvent({ ...inforNodeEvent, action: "view" })
    }
    else {
      pushToast(message, "warning")
    }
  }

  const onConfirmDelete = async () => {
    pushLoading(true)

    if (!inforNodeEvent?.item?.key && !selectedIdGroup.size) return
    const idGroup = selectedIdGroup.size ? Array.from(selectedIdGroup) : [Number(inforNodeEvent!.item!.key)]
    const result = await groupCustomerV2Api.deleteGroup(idGroup)
    if (result?.status) {
      pushToast(result.message, "success")
      closeModalDeleteGroup()
      gListGroup(pagination.pageSize, pagination.current)
    } else {
      pushToast(result?.message, "warning")
    }

    pushLoading(false)

  }

  const closeModalDeleteGroup = () => {
    setIsOpenModalDeleteGroup(false)
    setInforNodeEvent(undefined)
    setSelectedIdGroup(new Set())
  }

  const onSubmitFormCombine = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      pushToast(message, "success")
      setInforNodeEvent(undefined)
      gListGroup(pagination.pageSize, pagination.current)
    }
    else {
      pushToast(message, "warning")
    }
  }

  const handleOpenDataFields = () => {
    setIsSettingFields(true);
  };

  const onSaveDataFields = (iSsuccess?: boolean, message?: string, dataFilterActive?: FlattenedField[], dataFilterNoActive?: ListField[]) => {
    if (iSsuccess) {
      setIsSettingFields(false)
      pushToast(message, "success")
      setDataFieldsActive(dataFilterActive ?? [])
      setDataFieldsNoActive(dataFilterNoActive ?? [])
    } else {
      pushToast(message, "warning")
    }
  }

  const onCloseDataFields = () => {
    setIsSettingFields(false)
  }

  const onChangePositionGroup = useDebounce(async (positionGroup: groupCustomerV2Api.IPositionGroup[]) => {
    const result = await groupCustomerV2Api.updatePositionGroup(positionGroup)
    if (result?.status) {
      gListGroup()
      pushToast(result?.message, "success")
    } else {
      pushToast(result?.message, "warning")
    }
  }, 1000)

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    gListGroup(pageSize, pageNumber);
  };



  useEffect(() => {
    let unmounted = false;
    (async () => {
      const [resNationwide] = await Promise.all([getSLUnitByPermission(unitTemp)]);
      // if (!unmounted && resUnit?.status) setSLUnit(fommatSelectOptionUnit(resUnit.data));
      if (!unmounted && resNationwide?.status) setSLNationwide(convertNationwideValueToTree_V2(resNationwide.data));
    })();
    return () => {
      unmounted = true;
    }
  }, [unitTemp])

  useEffect(() => {
    const codes = dataFieldsActive.map(f => f.fieldCode)
    setColumnsMapShow(codes)
  }, [dataFieldsActive])

  //khi thay đổi item chọn
  // hoặc nhân bản
  useEffect(() => {
    if (inforNodeEvent?.action === "delete") {
      setIsOpenModalDeleteGroup(true)
    }
    setPreview(false)

    // if (inforNodeEvent?.action === "clone") {
    //   if (!inforNodeEvent?.dataClone) return
    //   const { parentId, level, status, type, title, description, infoFilter } = inforNodeEvent?.dataClone
    //   setInforNodeEvent({
    //     action: "add",
    //     item: {
    //       key: parentId ? parentId.toString() : "",
    //       parentId: parentId ?? 0,
    //       level: level ?? 0,
    //       title,
    //     },
    //     dataClone:inforNodeEvent?.dataClone
    //   })
    // }
  }, [inforNodeEvent, unitTemp]);

  useEffect(() => {
    gListGroup()

    //gộp nhóm và xem nhóm
    const { nodeEvent, itemCombineGroup } = (location.state || {})
    if (nodeEvent?.action === "combine" || nodeEvent?.action === "view") {
      if (nodeEvent?.action === "combine") {
        setInforNodeEvent(nodeEvent)
        setItemCombineGroup(itemCombineGroup)
      } else {
        setInforNodeEvent(nodeEvent)
      }
    } else {
      setInforNodeEvent(undefined)
    }
  }, [dataFilterList, unitTemp, location.state, displayType])

  //xóa ds
  useEffect(() => {
    setSelectedIdGroup(new Set())
  }, [displayType])

  //Làm phần khi vào nhóm từ menu thì set nhóm đầu tiên
  useEffect(() => {
    if (inforNodeEventLocation) {
      setInforNodeEvent(inforNodeEventLocation)
    }
    else {
      isMenuRef.current = isMenu ? true : false
    }

  }, [isMenu, inforNodeEventLocation])
  useEffect(() => {
    gListFieldsActive()
  }, [infoOperator])



  useEffect(() => {
    setInfoOperator(initInfoOperator)
  }, [inforNodeEvent?.action])
  return (
    <GroupContext.Provider
      value={{
        infoOperator,
        // displayType, dataFilterList, sLUnit, sLCategoryCar,
        isModalLoadingSync, isLoadingListUnmatchedSync,
        displayType, dataFilterList, sLCategoryCar, sLNationwide,
        inforNodeEvent, itemCombineGroup,
        isPreview, isPrivate, dataFieldsActive, dataFieldsNoActive,
        ColumnsMapShow, listGroup,
        setInfoOperator,
        setIsModalLoadingSync, setIsLoadingListUnmatchedSync,
        setDataFilterList, setInforNodeEvent,
        setPrivate, setPreview, setDataFieldsActive, setDataFieldsNoActive,
        setColumnsMapShow, handleOpenDataFields,
        onSubmitFormModalAdd, onSubmitFormModalUpdate, onSubmitFormCombine
      }}>
      <Layout>

        <ModalDeleteGroup
          isOpen={isOpenModalDeleteGroup}
          inforNodeEvent={inforNodeEvent}
          onConfirm={onConfirmDelete}
          closeModal={closeModalDeleteGroup}
        />
        {
          isSettingFields ?
            <CustomerFeildsGroup
              isSettingShow={isSettingFields}
              dataFilterActive={dataFieldsActive}
              dataFilterNoActive={dataFieldsNoActive}

              onSaveDataFields={onSaveDataFields}
              onClose={onCloseDataFields}
            /> :
            null
        }
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: <Link to="/customer/list">Khách hàng</Link>, },
            {
              title: renderTitlePage,
            },
          ]}
          title={<div className='custom-page-css flex items-center gap-2'>
            {inforNodeEvent?.action && <ArrowLeftOutlined className='custom-page-css text-sm' onClick={() => setInforNodeEvent(undefined)} />}
            <span>{renderTitlePage}</span>
          </div>}
        />
        {/* && !inforNodeEvent?.action */}
        {(!selectedIdGroup.size && (displayType === EDisplayGroupType.TREE || (displayType === EDisplayGroupType.LIST && !inforNodeEvent?.action))) &&
          (
            <div className="custom-page-css w-full flex justify-between pb-4">
              <div className="custom-page-css flex-5 flex gap-2 items-center">
                <span className='custom-page-css flex text-base font-light whitespace-nowrap'>Danh sách nhóm</span>
                <div className="custom-page-css flex items-center justify-between border-F2F4F7 flex-2 bg-FCFCFD rounded-2  pl-3   h-8 overflow-hidden">
                  <Input
                    placeholder="Tìm kiếm theo tên nhóm "
                    className="bg-FCFCFD border-none custom-input-focus none-focus-erro font-regular p-none-input  hover-none custom-input-css"
                    value={dataFilterList?.search}
                    onChange={(e) => setDataFilterList({ ...dataFilterList, search: e.target.value?.toString() || "" })}
                  />
                  <div className=" border-l-F2F4F7 h-full d-flex align-center">
                    <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
                  </div>
                </div>
                <ConfigProvider locale={viVN}>
                  <RangePicker
                    className="custom-input-date h-8"
                    // open={true}
                    placeholder={["Bắt đầu", "Kết thúc"]}
                    format="DD/MM/YYYY"
                    allowClear
                    value={[handleStringToDayJs(dataFilterList.dateStart), handleStringToDayJs(dataFilterList.dateEnd)]}
                    onReset={() => setDataFilterList({ ...dataFilterList, dateStart: undefined, dateEnd: undefined })}
                    onChange={(date) => setDataFilterList({ ...dataFilterList, dateStart: handleDateChangeDayJs(date?.[0]), dateEnd: handleDateChangeDayJs(date?.[1]) })}
                  // renderExtraFooter={() => (
                  //   <div className='w-full flex justify-end py-2'>
                  //     {/* <button className='border-none bg-096DD9 text-sm rounded-2 h-8 px-7-px font-regular text-white'
                  //             // onClick={handleReset}
                  //             >Làm mới</button> */}
                  //     <button className='border-none bg-096DD9 text-sm rounded-2 h-8 px-4 font-regular text-white'
                  //     // onClick={handleConfirm}
                  //     >Lưu</button>

                  //   </div>

                  // )}
                  />
                </ConfigProvider>
                <div className='custom-page-css flex-1 d-flex align-center gap-2 '>
                  <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pr-3  py-2-px h-8 justify-between overflow-hidden">
                    <div className="d-flex align-center  w-full">
                      <Select
                        // showSearch
                        allowClear
                        className="w-full  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none "
                        variant="borderless"
                        placeholder="Người tạo"
                        suffixIcon={null}
                        options={fommatSelectOptionCreator(sLStaff)}
                        value={dataFilterList.adminId}
                        onChange={(e) => setDataFilterList({ ...dataFilterList, adminId: e })}
                      />

                    </div>
                    <div className="  h-full d-flex align-center">
                      <DownOutlined className="text-sm text-98A2B3 " />
                    </div>
                  </div>
                </div>
                <div className='custom-page-css flex-1 d-flex align-center gap-2 '>
                  <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pr-3  py-2-px h-8 justify-between overflow-hidden">
                    <div className="d-flex align-center  w-full">
                      <Select
                        showSearch
                        allowClear
                        className="w-full  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none "
                        popupClassName='position-dropdow custome-select-item h-popUp'
                        variant="borderless"
                        placeholder="Loại nhóm"
                        suffixIcon={null}
                        options={dataTypeGroup}
                        value={dataFilterList.status}
                        defaultValue={2}
                        onChange={(e) => setDataFilterList({ ...dataFilterList, status: e })}
                      />

                    </div>
                    <div className="  h-full d-flex align-center">
                      <DownOutlined className="text-sm text-98A2B3 " />
                    </div>
                  </div>
                </div>

                <div className="custom-page-css flex gap-2 items-center">
                  <ApartmentOutlined
                    className={`custom-page-css ${displayType === EDisplayGroupType.TREE ? 'text-1890FF' : 'text-98A2B3'} `}
                    onClick={() => setDisplayType(EDisplayGroupType.TREE)}
                  />
                  <span className='custom-page-css text-E1E1E1'>|</span>
                  <BarsOutlined
                    className={`custom-page-css ${displayType === EDisplayGroupType.LIST ? 'text-1890FF' : 'text-98A2B3'} `}
                    onClick={() => setDisplayType(EDisplayGroupType.LIST)}
                  />
                </div>

              </div>
              <div className={`custom-page-css flex  gap-0  pl-3 ${!add && 'disabled'}`}
                onClick={() => navigate("/customer/group/grouping")}
              >
                <div className="custom-page-css flex items-center border-096DD9 rounded px-2 cursor-pointer">
                  <PlusCircleOutlined style={{ color: '#096DD9' }} />
                  <span className='custom-page-css text-base text-096DD9 font-regular pl-1'>Gộp nhóm</span>
                </div>

              </div>
              {
                displayType === EDisplayGroupType.LIST &&
                <div
                  className={`custom-page-css flex  gap-0  pl-3 ${!add && 'disabled'}`}
                  onClick={() => setInforNodeEvent({ action: "add", item: undefined })}
                >
                  <div
                    className="custom-page-css flex items-center border-096DD9 rounded px-2 cursor-pointer"
                    style={{
                      backgroundColor: "#096DD9",  // nền xanh
                      borderColor: "#096DD9",      // viền xanh
                    }}
                  >
                    <PlusCircleOutlined style={{ color: "#fff" }} />  {/* icon trắng */}
                    <span className="custom-page-css text-base text-white font-regular pl-1">
                      Tạo mới
                    </span>
                  </div>
                </div>
              }

            </div>
          )
        }

        {selectedIdGroup.size > 0 && (
          <div className='flex items-center gap-4 pb-3'>
            <span className='text-sm'>Đã chọn {selectedIdGroup.size} nhóm khách hàng</span>
            <div
              className={`custom-page-css flex items-center gap-1 cursor-pointer py-1 px-2 rounded border ${!isDelete && 'disabled'}`}
              onClick={() => setIsOpenModalDeleteGroup(true)}
            >
              <DeleteOutlined
                className={`text-F5222D text-sm  `}
              />
              <div className="custom-page-css text-sm">Xóa nhóm khách hàng</div>
            </div>
          </div>
        )}

        {
          (displayType === EDisplayGroupType.LIST && !inforNodeEvent?.action) &&
          <div className={`order-history-card__body custom-page-css flex flex-1 flex-col justify-between`}>
            <div className="ag-theme-alpine  custom-table-ag" style={{ width: '100%', height: 610 }}>

              <GroupCustomerTypeTree
                add={add}
                edit={edit}
                isDelete={isDelete}
                selectedIdGroup={selectedIdGroup}
                dataTable={listGroupTypeList}
                onAction={setInforNodeEvent}
                setSelectedIdGroup={setSelectedIdGroup}

              />
            </div>

            {/* Pagination */}
            <ConfigProvider locale={viVN}>
              <div className="pagination-block">
                <Pagination
                  showSizeChanger
                  current={pagination.current}
                  pageSize={pagination.pageSize}
                  total={pagination.total}
                  itemRender={(page, type, originalElement) => {
                    // Chỉ custom khi là nút số trang
                    if (type === 'page') {
                      return <span>{formatNumber(page)}</span>;
                    }
                    // prev / next / jump-prev / jump-next giữ nguyên
                    return originalElement;
                  }}
                  showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                  className='rs-pagination'
                  onChange={onPaginationChange}
                />
              </div>
            </ConfigProvider>
          </div>
        }
        {displayType === EDisplayGroupType.TREE &&
          <div className="custom-page-css w-full py-2 bg-096DD9 px-6">
            <span className='custom-page-css text-base text-white font-regular'>Danh sách nhóm</span>
          </div>
        }
        <div className={`${displayType === EDisplayGroupType.TREE ? ' bg-F8F8F8  gap-2 custom-page-css w-full flex  min-h-600px ' : ''}`} >
          {displayType === EDisplayGroupType.TREE &&
            <Splitter style={{}}>
              <Splitter.Panel defaultSize="20%" min="10%" max="100%" className='custom-page bg-white shrink-0 overflow-y-scroll' style={{ padding: 12, borderRight: "1px solid #f0f0f0" }}>

                <Sidebar
                  add={add}
                  edit={edit}
                  isDelete={isDelete}
                  data={listGroup}
                  inforNodeEvent={inforNodeEvent}
                  setInforNodeEvent={setInforNodeEvent}
                  onChangePositionGroup={onChangePositionGroup}
                />

              </Splitter.Panel>
              <Splitter.Panel>
                {/* No Access */}
                {!isAccess &&
                  <div className=" w-full h-auto p-4">
                    <div className="custom-page-css w-full h-full flex flex-col items-center justify-center gap-2 bg-white p-4 rounded">
                      <div className="custom-page-css h-294px w-254px">
                        <img src={no_access} className='h-full w-full object-contain' alt="No Access" />
                      </div>
                      <span className='custom-page-css text-xl text-344054 font-bold text-center'>Bạn không có quyền truy cập nhóm khách hàng này. <br />
                        Vui lòng liên hệ admin để được hỗ trợ.</span>
                    </div>
                  </div>
                }
                {
                  (inforNodeEvent?.action === 'add' || inforNodeEvent?.action === 'clone') &&
                  <AddNewGroup
                  />
                }
                {
                  inforNodeEvent?.action === 'view' &&
                  <ViewGroup
                  />
                }
                {
                  inforNodeEvent?.action === 'update' &&
                  <EditGroup
                  />
                }
                {
                  inforNodeEvent?.action === 'combine' &&
                  <CombineGroup
                  />
                }
              </Splitter.Panel>
            </Splitter>

          }



          {/* //Xem trước với có điều kiện */}


          {displayType === EDisplayGroupType.LIST && <>


            {
              (inforNodeEvent?.action === 'add' || inforNodeEvent?.action === 'clone') &&
              <AddNewGroup
              />
            }
            {
              inforNodeEvent?.action === 'view' &&
              <ViewGroup
              />
            }
            {
              inforNodeEvent?.action === 'update' &&
              <EditGroup
              />
            }
            {
              inforNodeEvent?.action === 'combine' &&
              <CombineGroup
              />
            }
          </>}
        </div>

      </Layout>
    </GroupContext.Provider >
  );
}

export default CustomerGroupV2
export const useCustomerGroupContext = () => useContext(GroupContext)!;
